module.exports = __webpack_public_path__ + "static/img/155.4951d767.png";